import {z} from '@hono/zod-openapi';

export const FastbackB2bDealersRequestSchema = z
  .object({
    tenantId: z.string().uuid(),
    credentials: z.object({
      clientId: z.string().trim().min(1),
      clientSecret: z.string().min(1),
    }),
  })
  .openapi('FastbackB2bDealersRequest');
